export const INIT_INGREDIENTS='INIT_INGREDIENTS'
export const ADD_INGREDIENT='ADD';
export const REMOVE_INGREDIENT='REMOVE';
export const SET_INGREDIENTS='SET_INGREDIENTS';
export const FETCH_INGREDIENTS_FAILED='FETCH_INGREDIENTS_FAILED';

export const POST_ORDER='POST_ORDER';
export const POST_ORDER_START='POST_ORDER_START';
export const POST_ORDER_SUCCESS='POST_ORDER_SUCCES';
export const POST_ORDER_FAIL='POST_ORDER_FAIL';

export const PURSHASE_BURGER_INIT='PURSHASE_BURGER_INIT';

export const FETCH_ORDERS ='FETCH_ORDERS';
export const FETCH_ORDERS_START='FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS='FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL='FETCH_ORDERS_FAIL';


export const AUTH_USER='AUTH_USER';
export const AUTH_START='AUTH_START';
export const AUTH_SUCCESS='AUTH_SUCCESS';
export const AUTH_FAIL='AUTH_FAIL';
export const CHECK_AUTH_STATE='CHECK_AUTH_STATE';//to handel auto Sign-in with saga


export const AUTH_INITIATE_LOGOUT ='AUTH_INITIATE_LOGOUT';
export const LOG_OUT='LOG_OUT';
export const LOG_OUT_SUCCESS='LOG_OUT_SUCCESS';
export const CHECK_AUTHT_IMEOUT = 'CHECK_AUTH_TIMEOUT';

export const SET_AUTH_REDIRECT ='SET_AUTH_REDIRECT';

